export default "__VITE_ASSET__dc744564__"